import * as ActionTypes from "./actionTypes";

export function getThemes(appKey) {
	return { type: ActionTypes.GET_THEMES, appKey };
}

export function getThemesSuccess(themes) {
	return { type: ActionTypes.GET_THEMES_SUCCESS, themes };
}

export function getThemesFailure(errorMessage) {
	return { type: ActionTypes.GET_THEMES_FAILURE, errorMessage };
}

export function createTheme(theme, appKey) {
	return { type: ActionTypes.CREATE_THEME, theme, appKey };
}

export function createThemeSuccess(appKey) {
	return { type: ActionTypes.CREATE_THEME_SUCCESS, appKey };
}

export function createThemeFailure(errorMessage) {
	return { type: ActionTypes.CREATE_THEME_FAILURE, errorMessage };
}

export function deleteTheme(theme, appKey) {
	return { type: ActionTypes.DELETE_THEME, theme, appKey };
}

export function deleteThemeSuccess(appKey) {
	return { type: ActionTypes.DELETE_THEME_SUCCESS, appKey };
}

export function deleteThemeFailure(errorMessage) {
	return { type: ActionTypes.DELETE_THEME_FAILURE, errorMessage };
}

export function selectTheme(theme) {
	return { type: ActionTypes.SELECT_THEME, theme };
}

export function selectThemeSuccess(theme) {
	return { type: ActionTypes.SELECT_THEME_SUCCESS, theme };
}

export function resetCurrentTheme() {
	return { type: ActionTypes.RESET_CURRENT_THEME };
}

export function selectThemeFailure(errorMessage) {
	return { type: ActionTypes.SELECT_THEME_FAILURE, errorMessage };
}

export function loadDefaultTheme() {
	return { type: ActionTypes.LOAD_DEFAULT_THEME };
}

export function loadDefaultThemeSuccess(theme) {
	return { type: ActionTypes.LOAD_DEFAULT_THEME_SUCCESS, theme };
}

export function loadDefaultThemeFailure(errorMessage) {
	return { type: ActionTypes.LOAD_DEFAULT_THEME_FAILURE, errorMessage };
}

export function editTheme(id, theme, appKey) {
	return { type: ActionTypes.EDIT_THEME, id, theme, appKey };
}

export function editThemeSuccess(appKey) {
	return { type: ActionTypes.EDIT_THEME_SUCCESS, appKey };
}

export function editThemeFailure(errorMessage) {
	return { type: ActionTypes.EDIT_THEME_FAILURE, errorMessage };
}

export function pickingThemeTemplate() {
	return { type: ActionTypes.PICKING_THEME_TEMPLATE };
}

export function pickingThemeTemplateFinished() {
	return { type: ActionTypes.PICKING_THEME_TEMPLATE_FINISHED };
}
